/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_TitleInputs */

const en_directory_promotion_title = /** @type {(inputs: Directory_Promotion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit with Sponsor benefits`)
};

const zh_directory_promotion_title = /** @type {(inputs: Directory_Promotion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 Sponsor 权益提交产品`)
};

/**
* | output |
* | --- |
* | "Submit with Sponsor benefits" |
*
* @param {Directory_Promotion_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_title = /** @type {((inputs?: Directory_Promotion_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_title(inputs)
	return zh_directory_promotion_title(inputs)
});
export { directory_promotion_title as "directory.promotion.title" }